/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/prop-types */
import React, { memo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  faAngleLeft,
  faAngleRight,
  faArrowsAlt,
  faClose,
  faFloppyDisk,
  faGear,
  faMagnifyingGlass,
  faPlay,
  faRotateLeft,
  faSitemap,
  faSquarePlus,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { faFileLines } from "@fortawesome/free-regular-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import MessageTemplatesList from "./MessageTemplatesList";
import ProjectStartForm from "./ProjectStartForm";
import Modules from "./Modules";
import MessageConfigsList from "./MessageConfigsList";
import BusinessHoursList from "./BusinessHoursList";
import Calendars from "./Calendars";
import {
  selectProjectLabel,
  selectProjectStatus,
} from "../../../store/slices/projectSlice";
import { setCurrentModal } from "../../../store/slices/modalsSlice";
import { selectFeatures } from "../../../store/slices/featuresSlice";
import ErrorsSidebar from "../ErrorsSidebar";
import { isUserPermitted } from "../../../helpers/pageProps";
import MyModal from "../../../Common/MyModal";
import VariableGroups from "./VariableGroups";
import ActionsPanel from "./ActionsPanel";
import { useConfirmDialog } from "../ConfirmDialogContext";

function SideMenu({
  addChild,
  redistribute,
  saveProject,
  zoomToFit,
  zoomToSelected,
  resetLayout,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const confirmDialog = useConfirmDialog();
  const [show, setShow] = useState(true);
  const projectLabel = useSelector(selectProjectLabel);
  const projectStatus = useSelector(selectProjectStatus);

  const { featuresBusinessHours, featuresCalendars, featuresModules } =
    useSelector(selectFeatures);

  return (
    <>
      <Collapse
        in={show}
        dimension="width"
        onEntered={redistribute}
        onExited={redistribute}
      >
        <div className="bg-loop bg-accross">
          <div className="side-menu h-100">
            {
              // Current project settings
              <div className="p-2">
                <h3>{projectLabel ?? "No project loaded"}</h3>
                <div className="bg-purple rounded-3 p-1">
                  <div className="m-0 d-flex align-items-baseline flex-wrap justify-content-between">
                    <span
                      title={
                        isUserPermitted("expert_logic_edit")
                          ? "Save project"
                          : "You don't have permission to save project"
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm border-0 me-1"
                        onClick={saveProject}
                        disabled={!isUserPermitted("expert_logic_edit")}
                      >
                        <FontAwesomeIcon icon={faFloppyDisk} />
                      </button>
                    </span>
                    <Link
                      className="btn btn-outline-secondary btn-sm border-0 me-1"
                      to={`/library/logic/builder/${params.projectID}/settings`}
                      title="Project settings"
                    >
                      <FontAwesomeIcon icon={faGear} />
                    </Link>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm border-0 me-1"
                      title="Close project"
                      onClick={async () => {
                        if (
                          projectLabel &&
                          !(await confirmDialog(
                            "Close project",
                            `Are you sure you want to close the project: "${projectLabel}"?`
                          ))
                        ) {
                          return;
                        }
                        navigate("/library/logic/builder/");
                      }}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm border-0 me-1"
                      onClick={redistribute}
                      title="Rearrange"
                    >
                      <FontAwesomeIcon icon={faSitemap} />
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm border-0 me-1"
                      onClick={resetLayout}
                      title="Reset layout"
                    >
                      <FontAwesomeIcon icon={faRotateLeft} />
                    </button>
                    {/* <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm border-0 me-1"
                      onClick={zoomToFit}
                      title="Zoom to fit"
                    >
                      <FontAwesomeIcon icon={faArrowsAlt} />
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm border-0 me-1"
                      onClick={zoomToSelected}
                      title="Zoom to selected"
                    >
                      <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </button> */}
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm border-0 me-1"
                      onClick={() => addChild()}
                      title="Add another workflow"
                    >
                      <FontAwesomeIcon icon={faSquarePlus} />
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm border-0 me-1"
                      onClick={() =>
                        dispatch(
                          setCurrentModal({
                            modal: "contacts",
                            tab: "contacts",
                          })
                        )
                      }
                      title="Manage contacts"
                    >
                      <FontAwesomeIcon icon={faUsers} />{" "}
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm border-0 me-1"
                      onClick={() =>
                        dispatch(
                          setCurrentModal({ modal: "reports", tab: "topics" })
                        )
                      }
                      title="Manage reporting"
                    >
                      <FontAwesomeIcon icon={faFileLines} />{" "}
                    </button>
                    {projectStatus === "draft" && (
                      <MyModal
                        heading="Start Project"
                        buttonClassName="btn btn-outline-secondary btn-sm border-0 me-1 px-2 py-1"
                        size="lg"
                        label={
                          <>
                            <FontAwesomeIcon icon={faPlay} className="me-2" />
                            Start
                          </>
                        }
                        disabled={params.projectID === "new"}
                        title={
                          params.projectID === "new"
                            ? "You need to save the project before starting"
                            : "Start project"
                        }
                        onShow={saveProject}
                      >
                        <ProjectStartForm
                          projectID={params.projectID}
                          showHiddenVariables
                        />
                      </MyModal>
                    )}
                  </div>
                </div>
                <ErrorsSidebar />
                <VariableGroups />
                <MessageTemplatesList />
                <MessageConfigsList />
                <ActionsPanel />
                {featuresBusinessHours && <BusinessHoursList />}
                {featuresCalendars && <Calendars />}
                {featuresModules && <Modules />}
              </div>
            }
          </div>
        </div>
      </Collapse>
      <button
        type="button"
        className="btn btn-light btn-sm rounded-0 border-0 opacity-50"
        onClick={() => {
          setShow((prev) => !prev);
        }}
        title="show/hide sidebar"
      >
        {show ? (
          <FontAwesomeIcon icon={faAngleLeft} />
        ) : (
          <FontAwesomeIcon icon={faAngleRight} />
        )}
      </button>
    </>
  );
}

export default memo(SideMenu);
